$.fn.MiniTabs = function() {
  let self = this
  let accordion_pos = self.offset().top + self.outerHeight(true)

  self.find('.accordion__header').on('click', function() {
    let header = $(this);
    header.next('.accordion__panel').each(function() {
      let accordionPanel = $(this)

      accordionPanel.sizer = function() {
        var header_pos = header.offset().top + header.outerHeight(true)
        var panel_height = accordionPanel.find('.accordion__panel-content').outerHeight(false)
        var available_space = accordion_pos - header_pos;
        if (available_space < panel_height) {
          self.css('--margin-bottom', panel_height - available_space + 'px')
        } else {
          self.css('--margin-bottom', '0')
        }
      }

      $(window).on('resize load orientationchange', accordionPanel.sizer)
      if (header.attr('aria-expanded') == 'true') {
        self.css('--margin-bottom', '0')
        self.removeClass('--open')
        self.removeClass('--already-open')
      } else {
        accordionPanel.sizer()
        if (self.hasClass('--open')) {
          self.addClass('--already-open')
        } else {
          self.addClass('--open')
        }
      }

    })
  })


  return function() {
    return self
  }()
}

$.fn.EmbeddedTabs = function() {
  let self = this

  self.find('.accordion__header').on('click', function() {
    let parentAccordion = self.closest('.page-section.js-accordion')
    let accordionPanel = parentAccordion.find('.accordion__panel')
    let textContent = accordionPanel.find('.accordion__panel-content')

    let delay = setTimeout(function(){
      let outerHeight = textContent.outerHeight(false)
      accordionPanel.css('max-height', outerHeight > 100 ? outerHeight + 'px' : '')
    }, 305);
  })

  return function() {
    return self
  }()
}
